module.exports = __webpack_public_path__ + "static/carbon-bundle-7f52aba069e5bfda2b2f849c8de151c5.png";